import React, { type FC } from 'react'
import {
  Badge,
  BADGE_TYPE_DEFAULT,
  BADGE_TYPE_SUCCESS,
  BADGE_TYPE_INFO,
  BADGE_TYPE_GREEN,
  BADGE_TYPE_ORANGE,
  BADGE_TYPE_WARNING,
} from 'mailup-web-components'
import { type FilterType } from '../../../types/beFiltersApi'
import { getFilterTypes } from '../services/filterTypes'

interface FilterTypeBadgeProps {
  fType: FilterType
}

// const colorVariants = {
//   Anagraphic: BADGE_TYPE_SUCCESS,
//   Activity: BADGE_TYPE_ORANGE,
//   Geolocation: BADGE_TYPE_GREEN,
//   Engagement: BADGE_TYPE_INFO,
//   Device: BADGE_TYPE_WARNING,
//   MultiFilter: BADGE_TYPE_DEFAULT,
//   MultiType: BADGE_TYPE_DEFAULT,
//   Tracking: BADGE_TYPE_INFO,
// }

export const FilterTypeBadge: FC<FilterTypeBadgeProps> = ({ fType }) => {
  const typeObj = getFilterTypes().find((t) => t.value === fType) ?? {
    label: fType,
    value: fType,
  }
  return (
    <Badge
      text={typeObj.label}
      type={BADGE_TYPE_INFO}
    />
  )
}
